import { countVisibleChars } from '../share/simple-html-editor-utils';

export const ADDITIONAL_COURSE_DETAIL_MAX_LENGTH = 1000;

export function validateAdditionalCourseDetails(courses: any[]): boolean {
    for (const course of courses) {
        const detail = course.additionalCourseDetail;
        if (detail && countVisibleChars(detail) > ADDITIONAL_COURSE_DETAIL_MAX_LENGTH) {
            return false;
        }
    }
    return true;
}
